/**
 * Currency Enumeration
 */
export enum CountryEnum {
  COL = "Colombia",
  EC = "Ecuador",
  MX = "Mexico",
  PE = "Peru",
  CL = "Chile",
  CR = "CostaRica",
  ES = "ElSalvador",
  GT = "Guatemala",
  HN = "Honduras",
  NI = "Nicaragua",
  PA = "Panama",
}



// WEBPACK FOOTER //
// ./src/shared/CountryEnum.ts